import api from '../../utils/axios';

const detalleCompraApi = {
  create: async (data: {
    IdCompra: number;
    Total: number;
  }) => {
    const response = await api.post('/detalle-compra/create', data);
    return response.data;
  },

  getByCompraId: async (idCompra: number) => {
    const response = await api.post(`/detalle-compra/findByCompra/${idCompra}`);
    return response.data;
  },
};

export default detalleCompraApi;